import { Link } from "react-router-dom";
import { Card } from "@/components/common";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#090B0E] p-6">
      <Card className="p-8 max-w-md w-full text-center" data-testid="payment-cancel-card">
        <div className="w-16 h-16 rounded-full mx-auto flex items-center justify-center bg-amber-500/15 text-amber-400">
          <XCircle className="w-8 h-8" />
        </div>
        <h1 className="font-head text-2xl font-bold text-slate-100 mt-5">Checkout canceled</h1>
        <p className="text-slate-400 mt-2 text-sm">No charge was made. You can pick a plan whenever you're ready.</p>
        <Link to="/billing" data-testid="back-to-billing" className="mt-6 inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-emerald-500 text-slate-950 font-semibold hover:bg-emerald-400 transition-colors">
          <ArrowLeft className="w-4 h-4" /> Back to Billing
        </Link>
      </Card>
    </div>
  );
}
